import { Client } from "../entities/ClientGetResponse";

export const ClientDetailLeftMenuButtons = ({
  direction,
  client,
  clientEmail,
  reload,
  toggleMenu,
  groupId
}: {
  direction?: "row" | "column";
  client: Client;
  clientEmail: string;
  reload: () => void;
  toggleMenu: () => void;
  groupId?: number;
}) => {
  const openIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="-2.5 -2.5 30 30"
      fill="none"
      className="clientDetailOpenIcon pointer"
      onClick={() => toggleMenu()}
      data-bs-toggle="collapse"
      data-bs-target="#collapseMenu"
      aria-expanded="false"
      aria-controls="collapseMenu"
    >
      <circle cx="12.5" cy="12.5" r="15" fill="#0076b6" />
      <path d="M7 8 L11 12 L7 16" fill="none" stroke="white" strokeWidth="2" />
      <path
        d="M14 8 L18 12 L14 16"
        fill="none"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );

  return (
    <div className={"pb-2 actions " + direction}>
      {direction === "column" && openIcon}
      {direction === "row" && (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="-2.5 -2.5 30 30"
            fill="none"
            className="clientDetailOpenIcon clientDetailOpenIcon-column pointer"
            style={{ right: 11, position: "absolute" }}
            onClick={() => toggleMenu()}
            data-bs-toggle="collapse"
            data-bs-target="#collapseMenu"
            aria-expanded="false"
            aria-controls="collapseMenu"
          >
            <circle cx="12.5" cy="12.5" r="15" fill="#0076b6" />
            <path
              d="M7 8 L11 12 L7 16"
              fill="none"
              stroke="white"
              strokeWidth="2"
            />
            <path
              d="M14 8 L18 12 L14 16"
              fill="none"
              stroke="white"
              strokeWidth="2"
            />
          </svg>
        </>
      )}
    </div>
  );
};
